// extracted by mini-css-extract-plugin
export default {"Toggle":"DCExpansionPanel_Toggle__Sh6Qh"};